import React, { useContext } from 'react';
import ChatPage from './ChatPage';
import Sidebar from '../components/Sidebar';
import ChatroomSidebar from '../components/ChatroomSidebar';
import CbtNavbar from '../components/CbtNavbar';
import FooterNav from '../components/FooterNav';
import { animated, useSpring } from "react-spring";
import { DataContext } from '../context/DataContext';

const MobileChatPage = () => {
    const dataContext = useContext(DataContext);
    const showMenu = dataContext.showMenu;
    const transitionStyles = useSpring({
        to: [
            { transform: 'translateX(0px)' },
        ],
        from: { transform: 'translateX(80px)' },
        config: { duration: 750 }
    });
    return (
        <>
            <animated.div style={transitionStyles} className="bg-gray-700 h-screen relative w-full">
                <div className="border-b border-gray-600 w-full bg-white">
                    <CbtNavbar />
                </div>
                {showMenu && 
                <div className='mt-16'>
                    <Sidebar />
                </div>
                }
                <div className='mt-24 w-full px-1'>
                    <ChatroomSidebar />
                </div>
                <div className='w-full sm:hidden z-10 absolute flex justify-between left-0 bottom-0'>
                    <FooterNav />
                </div>
            </animated.div>
        </>
    )
}

export default MobileChatPage;